module.exports = __webpack_public_path__ + "static/media/nodejs-logo.4e10752c.png";